<template>

  <CmorInvio />

</template>

<script>
import CmorInvio from '../components/pratiche/CmorInvio.vue'

export default {
  pageName: 'CmorInvio',
  components: {
    CmorInvio

  },
  data() {
    return {

    }
  },

  created(){
    
  },

  mounted(){
    this.$eventBus.emit('page-change', {
      target: this,
      currentRoute: this.$router.currentRoute.value
    })
  },

  methods: {
    
  },
}
</script>
